import { render, staticRenderFns } from "./Browse.vue?vue&type=template&id=20b0ab19"
import script from "./Browse.vue?vue&type=script&lang=js"
export * from "./Browse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports